<template>
    <div v-html="html">

    </div>
</template>

<script>
export default {
    name: "PreloadComponent",
    props: {
        slug: String
    },
    data() {
        return {
            html: '',
        }
    },
    methods: {
        afterScripts() {
            let appScript = document.createElement('script')
            appScript.setAttribute('src', '/js/app.js')
            document.head.appendChild(appScript)
        }
    },

    mounted() {
        axios.post(this.slug)
            .then(response => {
               // document.getElementById('loader').style.display = "flex";
               this.html = response.data
                setTimeout(() => {
                    this.afterScripts()
                }, 100)
            })
            .catch(error => {
                console.log(error);
            });
    }
}
</script>

<style scoped>

</style>
